import { Component, OnInit, SecurityContext } from "@angular/core";
import { AuthService } from "../../../core/auth/service/auth.service";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { UserDataService } from "src/app/core/service/user-data.service";
import { CommonModule } from "@angular/common";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

@Component({
  selector: 'app-error-auth',
  templateUrl: './error-auth.component.html',
  styleUrls: ['./error-auth.component.scss'],
  imports: [CommonModule, MatButtonModule, MatIconModule]
})
export class ErrorAuthComponent implements OnInit {
  showData = false;

  mensagem = 'Ocorreu um erro de autenticação.';
  mensagemHtml: string = '';

  constructor(
    private readonly authService: AuthService,
    private readonly userDataService: UserDataService,
    private readonly sanitizer: DomSanitizer
  ) {
    this.showData = !!this.userDataService.userData.getValue();
  }

  ngOnInit(): void {
    const st = history.state ?? {};
    const msg = st?.msg?.message ?? this.mensagem;
    this.mensagemHtml = this.sanitizer.sanitize(SecurityContext.HTML, msg);
  }

  loginAgain() {
    this.authService.logout(true);
  }

}